import { Tabs } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

const StyledTabs = withStyles({
  indicator: {
    height: 4,
    borderRadius: 12,
  },
})(Tabs)

export default StyledTabs
